import { useTheme } from "@mui/material";
import useAuth from "../../../auth/useAuth";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { changeStatusCompany, createNewCompany, updateCompanyData } from "../../../config.js";
import { tokens } from "../../../theme.js";

export const useCompany = () => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode)
    const auth = useAuth();
    const token = auth.globals.token

    const {
        showErrorRequest,
        alertSuccess
    } = Alerts();


    const createCompany = async (payload) => {
        if (payload) {
            try {
                let res = await createNewCompany(token, payload);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Crear Empresa", "La empresa se registro correctamente", "/Companies")
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Error en la creación de empresa", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }

    const updateCompany = async (companyId, body) => {
        if (body && companyId !== "") {
            try {
                let res = await updateCompanyData(token, body, companyId);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Editar Empresa", "La empresa se modifico correctamente", '/Companies')
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }

    const changeStatusCompanyById = async (companyId, newStatus) => {
        if (newStatus && companyId) {
            try {
                let res = await changeStatusCompany(token, companyId, newStatus);
                let data = await res.json()
                if (res.ok) {
                    alertSuccess("Cambio de Estado", "La empresa se modifico correctamente", '/Companies')
                    return data;
                } else {
                    if (res.status === 404) {
                        showErrorRequest("Registro no encontrado", auth)
                    }
                    if (res.status === 401 || res.status === 403) {
                        showErrorRequest("No tiene autorización o su sesión ha expirado", auth)
                    }
                    return undefined;
                }
            } catch (errorRequest) {
                showErrorRequest(errorRequest, auth)
                return undefined;
            }
        }
    }

    return {
        //properties
        theme,
        colors,
        token,
        auth,

        //methods
        createCompany,
        updateCompany,
        showErrorRequest,
        alertSuccess,
        changeStatusCompanyById

    }
}